import { render, staticRenderFns } from "./ElettrostimolatoreView.vue?vue&type=template&id=ebcf4650"
import script from "./ElettrostimolatoreView.vue?vue&type=script&lang=js"
export * from "./ElettrostimolatoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports